<div class="modal-content">
    <div class="modal-header">
        <h4 class="modal-title">{{ 'main.header.langSettings.title' | translate }}</h4>
        <button type="button" class="close" aria-label="Close" (click)="close()">
        <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="row">
            <div class="col-4 mb-2">
                <div class="d-grid gap-2">
                    <button class="btn btn-light" (click)="setLanguage(null)">
                        {{ 'languages.browserDefault' | translate }}
                    </button>
                </div>
            </div>
        </div>
        <hr>
        <div class="row">
            <ng-container *ngFor="let language of languages">
                <div class="col-4 mb-2">
                    <div class="d-grid gap-2">
                        <button class="btn btn-light" (click)="setLanguage(language)">
                            <span class="fi {{language.icon}}"></span> {{ language.name | translate }}
                        </button>
                    </div>
                </div>
            </ng-container>
        </div>

    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-dark" (click)="close()">{{ 'shared.closeBtn' | translate }}</button>
    </div>
</div>
